export default {
  taskUserName: (state) => (id) => {
    const u = id && state.users.find((x) => x.id === id);
    return (u && u.name) || null;
  },
};
